import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { i18nNamespaces } from 'srs.sharedcomponents/lib/esm/i18n/i18n'
import { useAppDispatch, useAppSelector } from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { setLoadBreadCrumbLocally } from 'srs.sharedcomponents/lib/esm/redux/slices/breadCrumbSlice'
import {
  setLastVisitedCatID,
  setLastVisitedSearch,
  selectLastVisitedSearch,
  updateIsSearching,
} from 'srs.sharedcomponents/lib/esm/redux/slices/productlistSlice'
import { removeSpecialCharacter } from 'srs.sharedcomponents/lib/esm/utils/validators'
import { getEnvBoolean } from 'srs.sharedcomponents/lib/esm/api/env'
import SearchForm from './SearchProducts'

type SearchProps = {}
const Search = (props: SearchProps) => {
  const [searchString, setSearchString] = useState('')
  const [productSearchError, setProductSearchError] = useState(false)
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const isPersistSearch = getEnvBoolean('REACT_APP_PERSIST_SEARCH')
  const lastVisitedSearch = useAppSelector(selectLastVisitedSearch)

  const onChange = (event: any) => {
    setSearchString(removeSpecialCharacter(event.target.value, [`\\/`]))
  }

  const resetErrorText = () => {
    setProductSearchError(false)
  }

  useEffect(() => {
    if (!isPersistSearch) {
      setSearchString('')
      return
    }
    const searchParams = new URLSearchParams(location.search)
    const hasSearch = searchParams.has('search')
    const isProductListCatalog = location.pathname.toLowerCase().includes('productlistcatalog')
    const isItemDetail = location.pathname.toLowerCase().includes('itemdetail')
    if (isProductListCatalog && hasSearch) {
      setSearchString(searchParams.get('search') || searchString)
    } else if (isItemDetail && lastVisitedSearch) {
      setSearchString(lastVisitedSearch)
    } else {
      setSearchString('')
      dispatch(setLastVisitedSearch(null))
    }
  }, [location])


  useEffect(() => {
    setProductSearchError(false)
  }, [history.length])

  useEffect(() => {
    document.body.addEventListener('click', resetErrorText, true)

    return () => document.body.removeEventListener('click', resetErrorText, true)
  }, [])

  const errMesage = () => {
    if (searchString.length === 0) {
      return t(`valSearch`, {
        ns: i18nNamespaces.coreSrsPrimary,
      })
    }

    if (searchString.length < 3 || searchString.length > 100) {
      return t(`Search_MinSearchError`, {
        ns: i18nNamespaces.coreSrsPrimary,
      })
    }
  }

  const onSubmit = (event: any) => {
    if (event.key === 'Enter' || event.type === 'click') {
      event.preventDefault()
      if (errMesage()) {
        setProductSearchError(true)
        return
      }
      if (productSearchError) setProductSearchError(false)
      dispatch(setLastVisitedCatID(null))
      dispatch(setLastVisitedSearch(searchString))
      dispatch(updateIsSearching(true))
      dispatch(setLoadBreadCrumbLocally(false))
      history.push(
        `/ProductListCatalog?search=${encodeURIComponent(searchString)}`,
      )
    }
  }

  return (
    <SearchForm
      searchString={searchString}
      onChange={onChange}
      onSubmit={onSubmit}
      productSearchError={productSearchError}
      errMesage={errMesage}
      t={t}
      namespace="coreSrsPrimary"
    />
  )
}

export { Search }
